/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import { Link, Route, RouteComponentProps, BrowserRouter as Router, Switch, NavLink } from 'react-router-dom'
import { IProductContentStateManager, ISectionInfo } from '../../services/ProductContentStateManager/contracts'
import { observer, Observer } from 'mobx-react'
import React from 'react'
// import { container } from '../../submodules/arc/configuration/ServiceLocator'
import { injectProperty, container } from '../../configuration/ServiceLocator'
import './Product.scss'
import { Accordion } from '../commons/Accordion/Accordion'
import ProductContent from './ProductContent/ProductContent'
import { IProducts, IProductStateManager, ISection } from '../../services/ProductStateManager/contracts'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FormFeedback, Input } from 'reactstrap'
import ReactDOM from 'react-dom'
import { Section } from '../Section/Section'
import { ISectionStateManager } from '../../services/SectionStateManager/contracts'
import { Content } from '../Content/Content'
import { IContentStateManager } from '../../services/ContentStateManager/contracts'
import ReactGA from 'react-ga4'
import { UserEventLogger } from '../../utils/UserEventLogger'
import { Breadcrumb, BreadcrumbItem } from 'reactstrap'

export interface IProductsProps extends RouteComponentProps<any> {
	productStateManager: IProductStateManager
}

export interface IProductsState {}

@observer
export class Product extends React.Component<IProductsProps, IProductsState> {
	mySearcInputRef: React.RefObject<any>
	public defaultProduct: string
	public defaultProductName: string
	public selectedSectionName: string

	node: any
	constructor(props: Readonly<IProductsProps>) {
		super(props)
		this.mySearcInputRef = React.createRef()
		this.defaultProduct = this.props.match.params ? this.props.match.params.productCode : ''
		this.defaultProductName = this.props.match.params ? this.props.match.params.productName : ''
		this.selectedSectionName = this.props.match.params ? this.props.match.params.sectionName : ''

		//optional route parmas
		if (this.props.match.params) {
			if (this.props.match.params.sectionid) {
				this.props.productStateManager.setSelectedType('section')
			} else this.props.productStateManager.setSelectedType('product')
		} else {
			this.props.productStateManager.setSelectedType('product')
		}

		this.props.productStateManager.getProductsfromJwt('JwtToken').catch(error => console.error(error))
		this.onSearchEnter = this.onSearchEnter.bind(this)
		this.onSearchButtonClick = this.onSearchButtonClick.bind(this)
		this.props.productStateManager.setSelectedProduct(this.defaultProduct, this.defaultProductName)
	}

	componentDidMount() {
		this.node = ReactDOM.findDOMNode(this)
		window.addEventListener('popstate', event => {
			window.location.reload()
		})
	}
	loadProductInfo(productCode: string, productName: string) {
		this.props.productStateManager.setSelectedType('product')
		this.props.productStateManager.setSelectedProduct(productCode, productName)
		this.defaultProduct = productCode
		this.defaultProductName = productName
		this.props.history.push('/pages/product/' + productCode + '/' + productName)
		this.selectedSectionName = ''
	}

	loadContentInformation(contenItemId: any) {
		this.props.productStateManager.setSelectedArticle(contenItemId)
		this.props.productStateManager.setSelectedType('content')
	}

	loadSectionInformation(event: any, sectionId: any, sectionName: string) {
		this.props.productStateManager.setSelectedSection(sectionId)
		this.props.productStateManager.setSelectedType('section')
		this.selectedSectionName = sectionName
		if (event) {
			this.handleUserClickEvent(event, 'SupportSite - Product/Section Page Accordion Section childitem Click', '')
		}
	}
	/**On Enter Key Press */
	onSearchEnter(event: any) {
		if (this.props.productStateManager.validateSearchTerm.isFieldValid('searchTerm')) {
			if (event.key === 'Enter') {
				event.preventDefault()
				event.stopPropagation()
				const searchTerm = event.target.value.trim()
				this.props.history.push('/pages/SearchResults?searchTerm=' + encodeURIComponent(searchTerm))
				this.handleUserClickEvent(event, 'SupportSite - Product/Section Page Search', 'Search - ' + searchTerm)
			}
		}
	}

	onSearchButtonClick(event: any) {
		if (this.props.productStateManager.validateSearchTerm.isFieldValid('searchTerm')) {
			this.props.history.push('/pages/SearchResults?searchTerm=' + encodeURIComponent(this.props.productStateManager.searchTerm))
			this.handleUserClickEvent(event, 'SupportSite - Product/Section Page Search', 'Search - ' + this.props.productStateManager.searchTerm)
		}
	}

	handleUserClickEvent(event: any, eventType: string, eventText: string) {
		UserEventLogger.handleUserClickEvent(event, eventType, eventText)
	}

	handleBreadCrumbClick(event: any) {
		UserEventLogger.handleUserClickEvent(event, 'SupportSite - Product/Section Page BreadCrumb Click', '')
	}

	render() {
		let template
		if (this.props.productStateManager.selectedType === 'product') {
			template = <ProductContent loadSectionInformation={(sectionId: any, sectionName: string) => this.loadSectionInformation(null, sectionId, sectionName)} loadContentInformation={(contenItemId: any) => this.loadContentInformation(contenItemId)} productName={this.props.productStateManager.selectedProductName} productCode={this.props.productStateManager.selectedProduct} productContentStateManager={container.get<IProductContentStateManager>('IProductContentStateManager')} />
		} else if (this.props.productStateManager.selectedType === 'section') {
			//optional route parms
			this.props.productStateManager.setSelectedProduct(this.defaultProduct, this.defaultProductName)
			if (this.props.match.params && this.props.match.params.sectionid) {
				this.props.productStateManager.setSelectedSection(this.props.match.params.sectionid)
			}

			// sectionId is the termContentItemId
			template = <Section sectionName={this.props.productStateManager.selectedSection} productCode={this.props.productStateManager.selectedProduct} loadContentInformation={(contenItemId: any) => this.loadContentInformation(contenItemId)} sectionStateManager={container.get<ISectionStateManager>('ISectionStateManager')} />
		} else if (this.props.productStateManager.selectedType === 'content') {
			template = <Content path={this.props.productStateManager.selectedArticle} contentStateManager={container.get<IContentStateManager>('IContentStateManager')} />
		}
		return (
			<div className="product-page-main-div">
				<div>
					<Breadcrumb>
						<BreadcrumbItem>
							<a href="/supportsite/pages/landingpage" onClick={this.handleBreadCrumbClick}>
								Support Home
							</a>
						</BreadcrumbItem>
						{this.selectedSectionName != '' && this.selectedSectionName != undefined ? (
							<BreadcrumbItem>
								<a href={'/supportsite/pages/product/' + this.defaultProduct + '/' + this.defaultProductName} onClick={this.handleBreadCrumbClick}>
									{this.defaultProductName}
								</a>
							</BreadcrumbItem>
						) : (
							<BreadcrumbItem active>{this.defaultProductName}</BreadcrumbItem>
						)}
						{this.selectedSectionName != '' && this.selectedSectionName != undefined ? <BreadcrumbItem active>{this.selectedSectionName}</BreadcrumbItem> : <></>}
					</Breadcrumb>
				</div>
				<div className="product-page-main-div-row">
					<div className="col-lg-3">
						<div className="mb-4">
							{/* <div className="small mb-3">Search</div> */}
							<div className="input-group">
								<Input className="form-control prod-search-no-border" autoComplete="off" ref={this.mySearcInputRef} name="searchTerm" placeholder="Search for..." type="text" onKeyUp={e => this.onSearchEnter(e)} value={this.props.productStateManager.searchTerm} onChange={e => this.props.productStateManager.setSearchTerm(e.target.value)} />
								<div className="input-group-append product-search-div">
									<button onClick={e => this.onSearchButtonClick(e)} type="button" className="btn btn-secondary search-btn search-btn-hgt">
										<FontAwesomeIcon icon={faSearch} />
									</button>
								</div>
								{/* <FormFeedback>{this.props.productStateManager.validateSearchTerm.getMessage('searchTerm')}</FormFeedback> */}
							</div>
						</div>
						<div className="mb-4">
							<div className="App">
								{this.props.productStateManager.products.map((product: IProducts, index: number) => {
									return (
										<Accordion
											loadProductInformation={(productCode: string, productName: string) => this.loadProductInfo(productCode, productName)}
											key={index}
											defaultProduct={this.defaultProduct}
											title={product.productName}
											productCode={product.productCode}
											content={product.sectionList.map((section: ISection, sectionindex) => {
												return (
													<Link className="product-list-group-item" key={sectionindex} onClick={e => this.loadSectionInformation(e, section.sectionId, section.sectionName)} to={'/pages/product/' + this.defaultProduct + '/' + product.productName + '/sectionid/' + section.sectionId + '/sectionName/' + section.sectionName}>
														{section.sectionName}
													</Link>
												)
											})}
										/>
									)
								})}
							</div>
						</div>
					</div>
					<div className="col-lg-8">
						{/* Right Container */}
						{template}
					</div>
				</div>
			</div>
		)
	}
}

export const ProductConnected = () => {
	const store = container.get<IProductStateManager>('IProductStateManager')

	return (
		<Route
			path="/pages/product/:productCode/:productName/(sectionid)?/:sectionid?/(contentItemId)?/:contentItemId?"
			render={props => {
				ReactGA.send({ hitType: 'pageview', page: 'props.location.pathname' })
				return <Product {...props} productStateManager={store} />
			}}
		/>
	)
}
